module.exports = __webpack_public_path__ + "img/logo_colorida.966b2fda.png";